// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.TimeIntervalStats .LoadingBlur {
  border-radius: 8px;
}
.TimeIntervalStats .CardHeader .card-icon {
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.TimeIntervalStats .time-interval-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.TimeIntervalStats .time-interval-card .card-body {
  padding: 24px;
}
.TimeIntervalStats .time-interval-content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 40px 20px;
}
.TimeIntervalStats .ready-state {
  text-align: center;
  max-width: 600px;
}
.TimeIntervalStats .ready-state .grid-icon-large {
  margin-bottom: 20px;
}
.TimeIntervalStats .ready-state .grid-icon-large i {
  font-size: 48px;
  color: #6c757d;
  background: #e9ecef;
  padding: 24px;
  border-radius: 8px;
  width: 96px;
  height: 96px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.TimeIntervalStats .ready-state .ready-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}
.TimeIntervalStats .ready-state .ready-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 32px;
  line-height: 1.5;
}
.TimeIntervalStats .ready-state .data-features {
  margin-bottom: 32px;
  text-align: left;
}
.TimeIntervalStats .ready-state .data-features .features-header {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  text-align: center;
}
.TimeIntervalStats .ready-state .data-features .features-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.TimeIntervalStats .ready-state .data-features .features-list li {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  position: relative;
  padding-left: 20px;
}
.TimeIntervalStats .ready-state .data-features .features-list li:before {
  content: "•";
  color: #007bff;
  font-weight: bold;
  position: absolute;
  left: 0;
}
.TimeIntervalStats .ready-state .data-features .features-list li:last-child {
  margin-bottom: 0;
}
.TimeIntervalStats .ready-state .get-started-section .get-started-text {
  font-size: 14px;
  font-weight: 600;
  color: #007bff;
  margin-bottom: 8px;
}
.TimeIntervalStats .ready-state .get-started-section .get-started-description {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.4;
}
.TimeIntervalStats .Table .TimeIntervalRow .TableCell .TableCell-Content {
  font-weight: 600;
}
.TimeIntervalStats .Table .TimeIntervalRow .PeriodCell,
.TimeIntervalStats .Table .TimeIntervalRow .TimeFrameCell,
.TimeIntervalStats .Table .TimeIntervalRow .WeekdayAvgCell,
.TimeIntervalStats .Table .TimeIntervalRow .WeekendAvgCell {
  width: 17.5%;
}
.TimeIntervalStats .Table .TimeIntervalRow .MinutesCell {
  width: 6%;
}
.TimeIntervalStats .Table .TimeIntervalRow .WeekdayAvgCell .TableCell-Content,
.TimeIntervalStats .Table .TimeIntervalRow .WeekendAvgCell .TableCell-Content,
.TimeIntervalStats .Table .TimeIntervalRow .MinutesCell .TableCell-Content {
  text-align: right;
}
.TimeIntervalStats .Table .TimeIntervalRow .WeekdayAvgCell .TableCell-Content:after,
.TimeIntervalStats .Table .TimeIntervalRow .WeekendAvgCell .TableCell-Content:after {
  font-size: 0.9rem;
  line-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/TimeIntervalStats/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACd;EACE,kBAAA;AACJ;AAEI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAN;AAGE;EACE,yBAAA;EACA,kBAAA;EACA,wCAAA;AADJ;AAGI;EACE,aAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAHJ;AAME;EACE,kBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,mBAAA;AAJN;AAMM;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAQI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AANN;AASI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAPN;AAUI;EACE,mBAAA;EACA,gBAAA;AARN;AAUM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AARR;AAWM;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AATR;AAWQ;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AATV;AAWU;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;AATZ;AAYU;EACE,gBAAA;AAVZ;AAiBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAfR;AAkBM;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AAhBR;AAuBQ;EACE,gBAAA;AArBV;AAwBM;;;;EAIE,YAAA;AAtBR;AAwBM;EACE,SAAA;AAtBR;AA2BQ;;;EACE,iBAAA;AAvBV;AA6BU;;EACE,iBAAA;EACA,iBAAA;AA1BZ","sourcesContent":[".TimeIntervalStats {\n  .LoadingBlur {\n    border-radius: 8px;\n  }\n  .CardHeader {\n    .card-icon {\n      flex-grow: 0;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  .time-interval-card {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    .card-body {\n      padding: 24px;\n    }\n  }\n\n  .time-interval-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 300px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    padding: 40px 20px;\n  }\n\n  .ready-state {\n    text-align: center;\n    max-width: 600px;\n\n    .grid-icon-large {\n      margin-bottom: 20px;\n\n      i {\n        font-size: 48px;\n        color: #6c757d;\n        background: #e9ecef;\n        padding: 24px;\n        border-radius: 8px;\n        width: 96px;\n        height: 96px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n\n    .ready-title {\n      font-size: 20px;\n      font-weight: 600;\n      color: #333;\n      margin-bottom: 12px;\n    }\n\n    .ready-description {\n      font-size: 14px;\n      color: #666;\n      margin-bottom: 32px;\n      line-height: 1.5;\n    }\n\n    .data-features {\n      margin-bottom: 32px;\n      text-align: left;\n\n      .features-header {\n        font-size: 12px;\n        font-weight: 600;\n        color: #666;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        margin-bottom: 12px;\n        text-align: center;\n      }\n\n      .features-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n\n        li {\n          font-size: 14px;\n          color: #333;\n          margin-bottom: 8px;\n          position: relative;\n          padding-left: 20px;\n\n          &:before {\n            content: '•';\n            color: #007bff;\n            font-weight: bold;\n            position: absolute;\n            left: 0;\n          }\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n\n    .get-started-section {\n      .get-started-text {\n        font-size: 14px;\n        font-weight: 600;\n        color: #007bff;\n        margin-bottom: 8px;\n      }\n\n      .get-started-description {\n        font-size: 14px;\n        color: #666;\n        margin: 0;\n        line-height: 1.4;\n      }\n    }\n  }\n  .Table {\n    .TimeIntervalRow {\n      .TableCell {\n        .TableCell-Content {\n          font-weight: 600;\n        }\n      }\n      .PeriodCell,\n      .TimeFrameCell,\n      .WeekdayAvgCell,\n      .WeekendAvgCell {\n        width: calc(70% / 4);\n      }\n      .MinutesCell {\n        width: calc(30% / 5);\n      }\n      .WeekdayAvgCell,\n      .WeekendAvgCell,\n      .MinutesCell {\n        .TableCell-Content {\n          text-align: right;\n        }\n      }\n      .WeekdayAvgCell,\n      .WeekendAvgCell {\n        .TableCell-Content {\n          &:after {\n            font-size: 0.9rem;\n            line-height: 1rem;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
